angular.module("ainapp")
    .controller("warehouseStockValuationController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Warehouse Wise Stock List";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Brands = [];
            MainService.BrandsInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Brands = response.data;
                $scope.Brands.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.Categories = [];
            MainService.ProductsParentList("Product").then(function (response) {
                $scope.Categories = response.data;
            });

            $scope.GetSub = function () {
                $scope.Parents = [];
                MainService.ProductSubList($scope.filter.ProductGroupId, "Product").then(function (response) {
                    $scope.Parents = response.data;
                });
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {

                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                };
                                o.data.filter.filters.push(temp);
                            }
                        }

                        MainService.productForMultiSelect(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            //toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 50
            };

            $scope.selectProductsOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                filter: "contains",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };

            $scope.selectProductCodeOptions = {
                placeholder: "Select Product Codes...",
                dataTextField: "ProductCode",
                dataValueField: "Id",
                filter: "contains",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };


            $scope.warehouseSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        MainService.WarehouseInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            //toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 20
            };

            $scope.selectWarehouseOptions = {
                placeholder: "Select Warehouse...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.warehouseSelectDataSource
            };



            $scope.loadKendoFunc = function () {
                $scope.KendoSource = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {
                            if ($scope.filter.isLoad) {
                                o.data.Keyword = $scope.filter.Keyword;
                                o.data.ProductIds = $scope.filter.ProductIds;
                                o.data.WarehouseIds = $scope.filter.WarehouseIds;
                                o.data.ProductGroupId = $scope.filter.ProductGroupId;
                                o.data.ProductParentId = $scope.filter.ProductParentId;
                                o.data.Level = $scope.filter.Level;

                                o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                                o.data.FromDay = $scope.filter.FromDate.getDate();
                                o.data.FromYear = $scope.filter.FromDate.getFullYear();

                                o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                                o.data.ToDay = $scope.filter.ToDate.getDate();
                                o.data.ToYear = $scope.filter.ToDate.getFullYear();


                                MainService.WarehouseStockList(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("NetworkError");
                                })
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        },

                    },
                    change: function (data) {
                        if (data.items.length > 0) {
                            console.log(data);
                            var arr = [];
                            angular.forEach($scope.Warehouses, function (e) {
                                var field = e.Name.replace(/ /g, '');
                                field = field.replace('&', '');
                                field = field.replace('/', '');
                                field = field.replace('.', '');
                                arr.push('CC' + field);
                            })
                            angular.forEach(data.items, function (e) {
                                angular.forEach(arr, function (ar) {

                                    angular.forEach(e.Warehouses, function (a) {

                                        var afield = a.Name.replace(/ /g, '');
                                        afield = afield.replace('&', '');
                                        afield = afield.replace('/', '');
                                        afield = afield.replace('.', '');
                                        afield = "CC" + afield;

                                        if (afield == ar) {
                                            e[ar] = a.BalanceQty;
                                        }
                                    })


                                })
                            })
                        }
                    },
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: $scope.Fields
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    pageSize: 20,
                    // group: [{
                    //     field: "WarehoueName",
                    //     aggregates: [
                    //         {
                    //             field: "Balance",
                    //             aggregate: "sum"
                    //             },
                    //         ]
                    //     }],
                    aggregate: $scope.Aggregates,
                });

                $scope.KendoGridOptions = {

                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 700,
                    resizable: true,
                    dataSource: $scope.KendoSource,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: true,
                    filterable: false,
                    groupable: false,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },



                    columns: $scope.Columns
                };

            }

            $scope.$on('$includeContentLoaded', function (event, templateName) {
                if (templateName === 'templates/common/stockFilterModal.html') {
                    $('#filterModal').modal('show');
                }
            });

            $scope.Init = function () {

                $scope.date1 = new Date();
                var n = $scope.date1.getFullYear();
                $scope.d2 = new Date("01/01/" + n);

                $scope.filter = {
                    FromDate: $scope.d2,
                    ToDate: new Date(),
                    ProductIds: [],
                    WarehouseIds: [],
                    isLoad: false,
                    Keyword: "",
                    BranchId: "",
                    Level: $stateParams.Level,
                }

                $scope.Warehouses = [];
                MainService.WarehousesInDropdownByLevel($stateParams.Level).then(function (response) {
                    $scope.Warehouses = response.data;

                    $scope.Columns = [
                        {
                            field: "ProductCode",
                            title: "Product Code",
                            width: '100px',
                        },
                        {
                            field: "Name",
                            title: "Name",
                            headerTemplate: "{{LanguageData.Name}}",
                            width: '100px',
                        },
                        {
                            field: "GroupName",
                            title: "Sub Category",
                            width: '100px',
                        },
                        {
                            field: "AveragePrice",
                            title: "Average Price",
                            width: '100px',
                        },
                        {
                            field: "Balance",
                            title: "Balance",
                            width: '100px',
                        },
                        {
                            field: "TotalValue",
                            title: "Total Value",
                            width: '100px',
                        },
                    ]

                    $scope.Aggregates = [];
                    $scope.Fields = [
                        {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            NameAr: {
                                type: "string",
                                editable: false,
                            },
                            ProductCode: {
                                type: "string",
                                editable: false,
                            },
                            GroupName: {
                                type: "string",
                                editable: false,
                            },

                            ParentGroupName: {
                                type: "string",
                                editable: false,
                            },
                            AveragePrice: {
                                type: "number",
                                editable: false,
                            },
                            Balance: {
                                type: "number",
                                editable: false,
                            },
                            TotalValue: {
                                type: "number",
                                editable: false,
                            },
                        }
                    ]

                    angular.forEach($scope.Warehouses, function (e) {

                        var field = e.Name.replace(/ /g, '');
                        field = field.replace('&', '');
                        field = field.replace('/', '');
                        field = field.replace('.', '');

                        var clm = {
                            title: e.Name,
                            field: field + "Qty",
                            width: '100px',
                            aggregates: ["sum"],
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                        }
                        $scope.Columns.push(clm);

                        var clm2 = {
                            title: "Value",
                            field: field + "Value",
                            width: '100px',
                            aggregates: ["sum"],
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                        }
                        $scope.Columns.push(clm2);


                        var aggrigate = {
                            field: field + "Qty",
                            aggregate: "sum"
                        }

                        $scope.Aggregates.push(aggrigate);

                        var aggrigate2 = {
                            field: field + "Value",
                            aggregate: "sum"
                        }

                        $scope.Aggregates.push(aggrigate2);

                        let obj = {
                            [field + "Qty"]: {
                                type: "number",
                                editable: false
                            }
                        };

                        $scope.Fields.push(obj);

                        let obj2 = {
                            [field + "Value"]: {
                                type: "number",
                                editable: false
                            }
                        };

                        $scope.Fields.push(obj2);


                    })

                    $scope.loadKendoFunc();

                });



            }
            $scope.Init();



            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.filterData = function () {
                $scope.filter.isLoad = true;
                $('#filterModal').modal('hide');
                console.log($scope.filter)
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refreshData = function () {
                $scope.Init();
                $('#filterModal').modal('show');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.Recalculate = function (id) {
                MainService.RecalculateProductStockBalance(id).then(function (response) {
                    if (response.data) {
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                    } else {
                        toastr.error("Network Error");
                    }
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }



        }])
